// SupplierAlarm.js
import React, { useEffect, useState } from "react";
import { getDatabase, ref, onValue, set } from "firebase/database";
import "./Alerts.css";
import InfoIcon from "./infoIcon";
import { getAuth } from "firebase/auth";

const SupplierAlarm = () => {
  const [companies, setCompanies] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState("");
  const [alertType, setAlertType] = useState("");
  const [reason, setReason] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [companyUserMap, setCompanyUserMap] = useState({});

  const alertTypes = [
    "Delay in supply",
    "Truck No. and Driver No. Unavailable",
    "Defected Material",
    "Quantity Shortage",
    "Other",
  ];

  useEffect(() => {
    const db = getDatabase();
    const profileRef = ref(db, "profileDashboard");
    onValue(profileRef, (snapshot) => {
      if (snapshot.exists()) {
        const profiles = snapshot.val();
        const companySet = new Set();
        const userMap = {};
        Object.entries(profiles).forEach(([userId, profile]) => {
          if (profile.company_name) {
            companySet.add(profile.company_name);
            userMap[profile.company_name] = userId; // map company -> userId
          }
        });
        setCompanies(Array.from(companySet));
        setCompanyUserMap(userMap); // save mapping here
      } else {
        console.warn("No company names found in profileDashboard.");
        setCompanies([]);
        setCompanyUserMap({});
      }
      setLoading(false);
    });
  }, []);

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!selectedCompany || !alertType || !reason) {
      setError("Please fill in all required fields.");
      return;
    }

    try {
      const db = getDatabase();
      // Get userId for selected company
      const userIdForCompany = companyUserMap[selectedCompany];
      if (!userIdForCompany) {
        setError("User ID for selected company not found.");
        return;
      }

      const alertId = Date.now();
      const alertData = {
        company_name: selectedCompany,
        type: alertType,
        reason,
        lastUpdated: new Date().toISOString(),
        isNew: true,
      };

      // Save under the company user's ID node
      await set(ref(db, `alerts/${userIdForCompany}/${alertId}`), alertData);
      
      alert("Alert submitted successfully!");
      setSelectedCompany("");
      setAlertType("");
      setReason("");
      setError("");
    } catch (err) {
      console.error("Error submitting alert:", err);
      setError("Failed to submit the alert. Please try again.");
    }
  };

  if (loading) return <p>Loading company names...</p>;

  return (
    <div className="supplier-alt-alarm">
      <div className="flex items-center space-x-2">
        <h1 className="text-xl font-semibold">
          Quick Alerts{" "}
          <InfoIcon text="This section allows you to raise supplier-related issues for prompt resolution. If you encounter problems such as supply delays, missing truck or driver details, defective materials, or quantity shortages, you can report them here. Select the relevant company and alert type, provide a reason, and submitted alerts will be recorded in the system and marked as new, ensuring quick visibility and response from relevant stakeholders." />
        </h1>
      </div>
      {error && <p className="error-message">{error}</p>}
      <form onSubmit={handleSubmit}>
        <div>
          <label htmlFor="company">Select Company:</label>
          <select
            id="company"
            value={selectedCompany}
            onChange={(e) => setSelectedCompany(e.target.value)}
            required
          >
            <option value="">--Select Company--</option>
            {companies.map((company) => (
              <option key={company} value={company}>
                {company}
              </option>
            ))}
          </select>
        </div>
        <div>
          <label htmlFor="alertType">Alert Type:</label>
          <select
            id="alertType"
            value={alertType}
            onChange={(e) => setAlertType(e.target.value)}
            required
          >
            <option value="">--Select Alert Type--</option>
            {alertTypes.map((type) => (
              <option key={type} value={type}>
                {type}
              </option>
            ))}
          </select>
        </div>
        <div>
          <label htmlFor="reason">Reason:</label>
          <textarea
            id="reason"
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            required
          />
        </div>
        <button
          type="submit"
          style={{
            backgroundColor: "#007BFF",
            color: "#fff",
            padding: "10px 20px",
            border: "none",
            borderRadius: "5px",
            cursor: "pointer",
          }}
        >
          Submit Alert
        </button>
      </form>
    </div>
  );
};

export default SupplierAlarm;